import React from "react";
import styles from "./selectionPanel.module.css";

// One side of an incompatibility rule: pick a group, then the whole group or specific options.
export default function SelectionPanel({ label, selection, otherId, groups, disabled, onChange }) {
    const group = groups.find((item) => item.id === Number(selection.attribute_id));

    const toggleOption = (id) => onChange({
        ...selection,
        value_ids: selection.value_ids.includes(id)
            ? selection.value_ids.filter((value) => value !== id)
            : [...selection.value_ids, id],
    });

    return (
        <fieldset className={styles.panel} disabled={disabled}>
            <legend className={styles.legend}>{label}</legend>
            <label className={styles.field}>
                <span className={styles.fieldLabel}>Attribute group</span>
                <select
                    className={styles.select}
                    value={selection.attribute_id}
                    onChange={(event) => onChange({
                        ...selection,
                        attribute_id: Number(event.target.value) || "",
                        entire_group: true,
                        value_ids: [],
                    })}
                >
                    <option value="">Choose a group</option>
                    {groups.filter((item) => item.id !== Number(otherId)).map((item) => (
                        <option key={item.id} value={item.id}>{item.name}{item.required ? " (required)" : ""}</option>
                    ))}
                </select>
            </label>

            {!group && <p className={styles.hint}>Choose a group, then decide whether to block all or selected options.</p>}

            {group && (
                <>
                    <div className={styles.scope} role="group" aria-label={`${label} scope`}>
                        <button
                            type="button"
                            aria-pressed={selection.entire_group}
                            className={`${styles.scopeOption}${selection.entire_group ? ` ${styles.scopeOptionSelected}` : ""}`}
                            onClick={() => onChange({ ...selection, entire_group: true, value_ids: [] })}
                        >
                            Entire group
                        </button>
                        <button
                            type="button"
                            aria-pressed={!selection.entire_group}
                            className={`${styles.scopeOption}${!selection.entire_group ? ` ${styles.scopeOptionSelected}` : ""}`}
                            onClick={() => onChange({ ...selection, entire_group: false })}
                        >
                            Specific options
                        </button>
                    </div>

                    {selection.entire_group ? (
                        <div className={styles.summary}>
                            <strong className={styles.summaryTitle}>All {group.values.length} options</strong>
                            <p className={styles.summaryText}>Includes options added to this group in the future.</p>
                            <p className={styles.summaryText}>{group.values.map((item) => item.value).join(", ")}</p>
                        </div>
                    ) : (
                        <>
                            <div className={styles.toolbar}>
                                <span className={styles.toolbarCount}>{selection.value_ids.length} selected</span>
                                <button
                                    type="button"
                                    className={styles.toolbarButton}
                                    onClick={() => onChange({ ...selection, value_ids: group.values.map((item) => item.id) })}
                                >
                                    Select all
                                </button>
                                <button
                                    type="button"
                                    className={styles.toolbarButton}
                                    onClick={() => onChange({ ...selection, value_ids: [] })}
                                >
                                    Clear
                                </button>
                            </div>
                            <div className={styles.optionList} role="group" aria-label={`${group.name} options`}>
                                {group.values.map((item) => {
                                    const checked = selection.value_ids.includes(item.id);

                                    return (
                                        <label className={`${styles.option}${checked ? ` ${styles.optionSelected}` : ""}`} key={item.id}>
                                            <input
                                                type="checkbox"
                                                className={styles.checkbox}
                                                checked={checked}
                                                onChange={() => toggleOption(item.id)}
                                            />
                                            <span>{item.value}</span>
                                        </label>
                                    );
                                })}
                            </div>
                            <p className={styles.hint}>Only selected options. Future options are not included.</p>
                        </>
                    )}
                </>
            )}
        </fieldset>
    );
}
